module.exports = __webpack_public_path__ + "img/cimlapkep-head.25b56a84.png";